export type PersonType = {
  name: string;
  id: number;
};

export const PolicyOwner = {
  name: 'Policy Owner',
  id: 1,
};
export const PrimaryInsured = {
  name: 'Primary Insured',
  id: 2,
};

export const SpouseDependent = {
  name: 'Spouse Dependent',
  id: 3,
};

export const ChildDependent = {
  name: 'Child Dependent',
  id: 4,
};

export const PrimaryBeneficiary = {
  name: 'Primary Beneficiary',
  id: 5,
};

export const ContingentBeneficiary = {
  name: 'Contingent Beneficiary',
  id: 6,
};

// id: 7 is Other, which has been filtered out from the API
export const JointInsured = {
  name: 'Joint Insured',
  id: 8,
};

export const PersonTypes: PersonType[] = [
  PolicyOwner,
  PrimaryInsured,
  SpouseDependent,
  ChildDependent,
  PrimaryBeneficiary,
  ContingentBeneficiary,
  JointInsured,
];
